(function(){
  var body = document.querySelector('.mdp-adv2-body') || document.body;
  body.classList.add('js');
  // True inside the Shopify theme editor preview. In the editor, sections are
  // re-rendered on every setting change, which would leave freshly-injected
  // .a2-reveal elements stuck at opacity:0. So in design mode we never hide.
  var DESIGN = !!(window.Shopify && window.Shopify.designMode);

  // ---------- scroll reveal ----------
  var io = null;
  function ensureIO(){
    if(io) return io;
    io = new IntersectionObserver(function(entries){
      entries.forEach(function(en){ if(en.isIntersecting){ en.target.classList.add('in'); io.unobserve(en.target); } });
    }, { rootMargin:'0px 0px -8% 0px', threshold:0.08 });
    return io;
  }
  function reveal(scope){
    var els = (scope || document).querySelectorAll('.a2-reveal');
    if(!els.length) return;
    if(DESIGN || !('IntersectionObserver' in window)){
      els.forEach(function(e){ e.classList.add('in'); });
      return;
    }
    var obs = ensureIO();
    els.forEach(function(e){ obs.observe(e); });
  }

  // ---------- review carousel(s): arrows + dots + native swipe ----------
  function initCarousel(root){
    if(root.__rcar) return; root.__rcar = true;
    var vp = root.querySelector('[data-rviewport]');
    var cards = [].slice.call(root.querySelectorAll('.a2-rq'));
    var prev = root.querySelector('[data-rprev]'), next = root.querySelector('[data-rnext]');
    var dotsC = root.querySelector('[data-rdots]');
    if(!vp || !cards.length || !prev || !next || !dotsC) return;
    function perView(){ return window.matchMedia('(min-width:760px)').matches ? 2 : 1; }
    function pages(){ return Math.max(1, Math.ceil(cards.length / perView())); }
    function current(){ return Math.round(vp.scrollLeft / vp.clientWidth); }
    function update(){
      var c = current(), P = pages();
      [].forEach.call(dotsC.children, function(d,i){ d.classList.toggle('on', i===c); });
      prev.disabled = c<=0; next.disabled = c>=P-1;
    }
    function buildDots(){
      dotsC.innerHTML='';
      for(var i=0;i<pages();i++){
        (function(i){
          var d=document.createElement('button');
          d.className='a2-rdot'; d.setAttribute('aria-label','Go to review page '+(i+1));
          d.addEventListener('click', function(){ vp.scrollTo({left:i*vp.clientWidth, behavior:'smooth'}); });
          dotsC.appendChild(d);
        })(i);
      }
      update();
    }
    prev.addEventListener('click', function(){ vp.scrollBy({left:-vp.clientWidth, behavior:'smooth'}); });
    next.addEventListener('click', function(){ vp.scrollBy({left: vp.clientWidth, behavior:'smooth'}); });
    var raf; vp.addEventListener('scroll', function(){ cancelAnimationFrame(raf); raf=requestAnimationFrame(update); }, {passive:true});
    var rt; window.addEventListener('resize', function(){ clearTimeout(rt); rt=setTimeout(buildDots, 150); });
    buildDots();
  }
  function carousels(scope){
    (scope || document).querySelectorAll('[data-rcar]').forEach(initCarousel);
  }

  // ---------- Loox: hide the fallback carousel if the live widget renders ----------
  function initLoox(scope){
    var lr = (scope || document).querySelector('#looxReviews') || document.getElementById('looxReviews');
    var fb = (scope || document).querySelector('[data-loox-fallback]') || document.querySelector('[data-loox-fallback]');
    if(!lr || !fb || lr.__looxWatch) return;
    lr.__looxWatch = true;
    // In the editor, keep the fallback visible so the merchant can see/edit it.
    if(DESIGN){ return; }
    function hasReal(){ return lr.offsetHeight > 140 && (lr.innerText||'').trim().length > 40; }
    var n=0, t=setInterval(function(){
      if(hasReal()){ fb.style.display='none'; lr.style.display=''; clearInterval(t); }
      else if(++n > 12){ lr.style.display='none'; clearInterval(t); }
    }, 600);
  }

  reveal(document);
  carousels(document);
  initLoox(document);

  // ---------- Shopify theme-editor re-render support ----------
  // Fired when a section is re-rendered after a setting change. Without this,
  // edited images/sections stay invisible (reveal) or lose their carousel.
  document.addEventListener('shopify:section:load', function(e){
    var s = e.target;
    reveal(s);
    carousels(s);
    initLoox(s);
  });
})();
